/**
 * Narrows an `unknown` caught error to an object carrying a string-valued
 * `field`. Errors surfaced from promise rejections and event handlers are typed
 * `unknown`, and a DOMException isn't `instanceof Error` in every engine, so we
 * narrow by shape rather than by constructor.
 *
 * @example
 * if (hasErrorField(error, 'name') && error.name === 'NotAllowedError') { ... }
 */
export const hasErrorField = <Field extends string>(
    error: unknown,
    field: Field
): error is Record<Field, string> =>
    typeof error === 'object' &&
    error !== null &&
    field in error &&
    typeof (error as Record<Field, unknown>)[field] === 'string';
